import type {
    ViewStyle
} from "react-native";
import type {
    CollapsibleTriggerSizeConstantType,
    CollapsibleTriggerDynamicStyleType,
    CollapsibleTriggerMeasures,
    CollapsibleTriggerSize
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getControlMeasures
} from "../../../../helpers/theme/control";

export const COLLAPSIBLE_TRIGGER_SIZE: CollapsibleTriggerSize = "small";

export const getCollapsibleTriggerSize = ({
    controlPaddings,
    controlHeights,
    shapeConfigs,
    iconSizes
}: CollapsibleTriggerSizeConstantType): CollapsibleTriggerMeasures => {
    return getControlMeasures({
        size: COLLAPSIBLE_TRIGGER_SIZE,
        controlPaddings,
        controlHeights,
        shapeConfigs,
        iconSizes
    });
};

export const useStyles = ({
    currentSize
}: CollapsibleTriggerDynamicStyleType) => {
    const styles = {
        container: {
            marginStart: -currentSize.paddingHorizontal
        } as Mutable<ViewStyle>
    };

    return styles;
};
